import { useState } from "react";
import Image from "next/image";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { handlePlayPause } from "redux-share/actions/controller.actions";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));
const PlayPauseIcon = dynamic(() => import("./playPauseIcon"));

const PlayPauseControllbar = () => {

    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    useAppSelector(({ controller: { isEnded, play } }) => ({ isEnded, play }), shallowEqual);
    useAppSelector(({ videoData: { params } }) => ({ params }), shallowEqual);

    return (
        <div className="pl-relative">
            <div
                className="pl-flex pl-items-center"
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
            >
                {conditions(ConditionName.isEnded) ? <Image src={IMAGES.replay} alt="replay-icon" width={22} height={22} className={`${conditions(ConditionName.isLiveParam) ? "pl-opacity-50" : "pl-cursor-pointer"}`} onClick={(event:any) => conditions(ConditionName.isLiveParam) ? {} : handlePlayPause(event)} onDoubleClick={(event: any) => event.stopPropagation()} /> : <PlayPauseIcon onClick={handlePlayPause} onDoubleClick={(event: any) => event.stopPropagation()} />}
            </div>
            {showTooltip && <ControllbarTooltip title={conditions(ConditionName.isEnded) ? `بازپخش` : conditions(ConditionName.isPlay) ? "توقف (k)" : "پخش (k)"} className="pl-bottom-[260%] pl-right-[-35px]" />}
        </div>
    )
}

export default PlayPauseControllbar;